import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    // Check if this page was opened in a popup/new tab (from payment link)
    const isPopup = window.opener && !window.opener.closed;

    if (isPopup) {
      // If opened in popup, close the tab after 3 seconds
      console.log('Payment successful in popup window - closing in 3 seconds...');
      const timer = setTimeout(() => {
        window.close();
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      // If normal page navigation, redirect to dashboard after 5 seconds
      const timer = setTimeout(() => {
        navigate('/dashboard');
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 48px)',
      padding: '20px'
    }}>
      <Card style={{
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        padding: '40px 30px'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#d1fae5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <CheckCircle size={48} color="#10b981" />
        </div>

        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: 'var(--color-text-primary)',
          margin: '0 0 12px 0'
        }}>
          Payment Successful!
        </h1>

        <p style={{
          fontSize: '16px',
          color: 'var(--color-text-muted)',
          margin: '0 0 8px 0',
          lineHeight: '1.5'
        }}>
          Your payment has been processed successfully.
        </p>

        <p style={{
          fontSize: '14px',
          color: 'var(--color-text-disabled)',
          margin: '0 0 32px 0'
        }}>
          Your credits will be added to your account shortly.
        </p>

        {orderId && (
          <div style={{
            padding: '12px 16px',
            backgroundColor: 'var(--color-bg-inset)',
            borderRadius: '8px',
            marginBottom: '32px'
          }}>
            <p style={{
              fontSize: '12px',
              color: 'var(--color-text-muted)',
              margin: '0 0 4px 0'
            }}>
              Order ID
            </p>
            <p style={{
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--color-text-primary)',
              margin: 0,
              fontFamily: 'monospace'
            }}>
              {orderId}
            </p>
          </div>
        )}

        <Button
          onClick={() => navigate('/dashboard')}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
        >
          Go to Dashboard
          <ArrowRight size={18} />
        </Button>

        <p style={{
          fontSize: '12px',
          color: 'var(--color-text-disabled)',
          margin: '16px 0 0 0'
        }}>
          {window.opener && !window.opener.closed
            ? 'This tab will close automatically in 3 seconds...'
            : 'Redirecting automatically in 5 seconds...'}
        </p>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
